import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getTransaction = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.TRANSACTIONS +
        queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getWalet = () => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.WALLET, "GET", {
      "Content-Type": "application/json",
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAutoPay = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.AUTOPAY,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAutoRenewel = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.AUTORENEWEL,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const createOrder = (amountPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CREATE_ORDER,
      "POST",
      {
        "Content-Type": "application/json",
      },
      amountPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const verifyOrder = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.VERIFY_ORDER +
        `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const createRechargeRequest = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.RECHARGE_REQUEST,
      "POST",
      { "Content-Type": "application/json" },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getMyRechargeRequests = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.RECHARGE_REQUEST + queryParams,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getChartData = (year) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.WALLET_CHART_DATA +
        `${year}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const WalletApiService = {
  getTransaction,
  getWalet,
  getAutoPay,
  getAutoRenewel,
  createOrder,
  verifyOrder,
  getChartData,
  createRechargeRequest,
  getMyRechargeRequests,
};
